import { render, staticRenderFns } from "./descriptionInfo.vue?vue&type=template&id=680db3c5&scoped=true"
import script from "./descriptionInfo.vue?vue&type=script&lang=js"
export * from "./descriptionInfo.vue?vue&type=script&lang=js"
import style0 from "./descriptionInfo.vue?vue&type=style&index=0&id=680db3c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680db3c5",
  null
  
)

export default component.exports